export default __webpack_public_path__ + "static/media/element_spec_65.30d43e73.jpg";